import React, { useState } from 'react';
import { models } from "@vote4dance/judging-sdk";
import { Alert, Avatar, Checkbox, Collapse, List, Modal, Space, Typography } from 'antd';
var HeatsTeamItem = models.teams.HeatsTeamItem;
import { _T } from '../../../../../base-react/src/Localization';
const { Panel } = Collapse;
const formatChangeValue = (value) => {
    if (value === null || value === undefined || value === '') {
        return 'empty';
    }
    if (typeof value === 'boolean') {
        return value ? 'true' : 'false';
    }
    return String(value);
};
export const ImportTeamsModal = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { importCompare, open, onClose, onImport } = props;
    const { Text } = Typography;
    const [checked, setChecked] = useState({
        teams: {
            added: true,
            changed: true,
            removed: true,
            warnings: true
        },
        classes: {
            added: true
        }
    });
    if (!importCompare) {
        return null;
    }
    const teamModes = importCompare.teams || {};
    const hasAnyTeamChanges = ((_b = (_a = teamModes.added) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 ||
        ((_d = (_c = teamModes.changed) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0 ||
        ((_f = (_e = teamModes.removed) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 0 ||
        ((_h = (_g = teamModes.warnings) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 0) > 0;
    const getTypeFromMode = (mode) => {
        switch (mode) {
            case "added":
                return "success";
                break;
            case "changed":
                return "info";
                break;
            case "removed":
                return "error";
                break;
            case "warnings":
                return "warning";
                break;
        }
    };
    const renderTeamHeader = (item) => (React.createElement(Space, { style: { width: '100%', justifyContent: 'space-between' } },
        React.createElement(Space, null,
            React.createElement(Avatar, null, item.team_start_number),
            HeatsTeamItem.getFullNameWithOrg(item)),
        React.createElement(Text, { type: "secondary" }, item.team_starting_in ? item.team_starting_in : item.team_class)));
    const getFieldLabel = (field) => {
        return _T(`team.details.${field}.label`);
    };
    const renderChangeDescription = (item, field) => {
        var _a;
        const change = (_a = item.team_import_change_values) === null || _a === void 0 ? void 0 : _a[field];
        if (!change) {
            return field;
        }
        if (field === 'team_image_id') {
            if (change.to === null) {
                return _T('data.import.preview.image-cleared', {
                    field: getFieldLabel(field)
                });
            }
            if (change.from === null && change.to != null) {
                return _T('data.import.preview.image-set', {
                    field: getFieldLabel(field)
                });
            }
            return _T('data.import.preview.image-replaced', {
                field: getFieldLabel(field)
            });
        }
        return `${getFieldLabel(field)}: ${formatChangeValue(change.from)} -> ${formatChangeValue(change.to)}`;
    };
    return (React.createElement(Modal, { title: _T('data.import.title'), width: 1000, open: open, onCancel: onClose, onOk: () => onImport(checked) },
        React.createElement(Collapse, null,
            importCompare.classes && Object.keys(importCompare.classes).filter((mode) => importCompare.classes[mode].length > 0).map((mode) => React.createElement(Panel, { key: "classes-" + mode, header: React.createElement(Alert, { title: _T('common.' + mode, { name: _T('class.title') }) + ' - ' + importCompare.classes[mode].length, type: "success", action: React.createElement(Checkbox, { checked: checked.classes[mode], onClick: (event) => {
                            event.stopPropagation();
                            setChecked(prev => {
                                const copy = { ...prev };
                                copy.classes[mode] = !prev.classes[mode];
                                return copy;
                            });
                        } }) }) },
                React.createElement(List, { size: "small", bordered: true, dataSource: importCompare.classes[mode], renderItem: (item) => React.createElement(List.Item, null, item.class_label ? item.class_label : item.class_name) }))),
            !hasAnyTeamChanges && (React.createElement(Alert, { showIcon: true, type: "info", message: _T('common.none') })),
            importCompare.teams && Object.keys(importCompare.teams).filter((mode) => importCompare.teams[mode].length > 0).map((mode) => React.createElement(Panel, { key: "teams-" + mode, header: React.createElement(Alert, { title: _T('common.' + mode, { name: _T('team.title') }) + ' - ' + importCompare.teams[mode].length, type: getTypeFromMode(mode), action: React.createElement(Checkbox, { checked: checked.teams[mode], onClick: (event) => {
                            event.stopPropagation();
                            setChecked(prev => {
                                const copy = { ...prev };
                                copy.teams[mode] = !prev.teams[mode];
                                return copy;
                            });
                        } }) }) }, mode === 'changed' ? (React.createElement(Collapse, { size: "small", items: importCompare.teams[mode].map((item) => {
                    var _a, _b, _c, _d, _e;
                    return ({
                        key: `${(_c = (_b = (_a = item.team_id) !== null && _a !== void 0 ? _a : item.dance_team_id) !== null && _b !== void 0 ? _b : item.team_start_number) !== null && _c !== void 0 ? _c : 'team'}-${(_e = (_d = item.class_id) !== null && _d !== void 0 ? _d : item.team_class) !== null && _e !== void 0 ? _e : 'class'}`,
                        label: renderTeamHeader(item),
                        children: (React.createElement(List, { size: "small", bordered: true, dataSource: item.team_import_changes || [], renderItem: (field) => (React.createElement(List.Item, null, renderChangeDescription(item, field))), locale: {
                                emptyText: _T('common.empty')
                            } }))
                    });
                }) })) : (React.createElement(List, { size: "small", bordered: true, dataSource: importCompare.teams[mode], renderItem: (item) => React.createElement(List.Item, { actions: [item.team_starting_in ? item.team_starting_in : item.team_class] },
                    React.createElement(Space, null,
                        React.createElement(Avatar, null, item.team_start_number),
                        HeatsTeamItem.getFullNameWithOrg(item))) })))))));
};
